const site = process.env.SITE_NAME || 'nxhzz'
let siteConfig = require(`./${site}.js`)

export const getSiteConfig = () => {
    return siteConfig.default
}
